import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

// Props for useErrorStyles
interface ErrorStylesProps {
  height: string | number;
}

// Props for useStyles
interface StylesProps {
  height: string;
  isMobile: boolean;
}

export const useErrorStyles = makeStyles<Theme, ErrorStylesProps>((theme) => ({
  root: ({ height }) => ({
    borderRadius: "4px",
    border: `1px solid ${theme.palette.primary.main}`,
    height,
  }),
}));

const useStyles = makeStyles<Theme, StylesProps>(() => ({
  root: ({ height, isMobile }) => ({
    borderRadius: "4px",
    border: "1px solid #E3E5E5",
    padding: isMobile ? "16px" : "36px",
    height: `calc(${height})-2*36px`, // Note: This is a string but may not evaluate as expected
  }),
  periodTitle: {
    color: "#5E6366",
    fontFamily: "Mulish",
    fontSize: "16px",
    lineHeight: "25px",
    letterSpacing: "0.44px",
  },
  period: {
    fontFamily: "Mulish",
    fontSize: "34px",
    letterSpacing: "0.25px",
    color: "#5E6366",
    lineHeight: "42px",
  },
  divider: {
    padding: "16px 8px 0px 8px",
    borderBottom: "1px solid #E3E5E5",
    marginBottom: "32px",
  },
  skeleton: {
    marginTop: "-8px",
  },
}));

export default useStyles;
